module.exports = __webpack_public_path__ + "media/src/images/balloons/banner_weekendsale_small_en-20954e0195c8d047fa8ac95582a72b3d.jpg";